// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueTouch from 'vue-touch'
import 'lib-flexible'
import Track from '@/plugins/Track'
import WxShare from '@/plugins/WxShare'
import NativeInterface from '@/plugins/NativeInterface'
import App from '@/App'
import store from '@/store'
import router from '@/router'

Vue.config.productionTip = false
Vue.use(VueTouch, {name: 'touch'})
// use default plugins
Vue.use(Track, {
  appName: 'lls',
  appVersion: '5.9',
  category: 'web',
  basicParams: {
    campaign_name: '2017_report'
  }
})
Vue.use(WxShare)
Vue.use(NativeInterface)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js